'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var types_gen = require('../raw/dashboard/x/types.gen.cjs');

"use strict";
var VariableHide = /* @__PURE__ */ ((VariableHide2) => {
  VariableHide2[VariableHide2["dontHide"] = 0] = "dontHide";
  VariableHide2[VariableHide2["hideLabel"] = 1] = "hideLabel";
  VariableHide2[VariableHide2["hideVariable"] = 2] = "hideVariable";
  VariableHide2[VariableHide2["inControlsMenu"] = 3] = "inControlsMenu";
  return VariableHide2;
})(VariableHide || {});
const defaultDashboard = types_gen.defaultDashboard;
const defaultVariableModel = {
  ...types_gen.defaultVariableModel
};
const defaultTimePickerConfig = types_gen.defaultTimePickerConfig;
const defaultPanel = types_gen.defaultPanel;
const defaultRowPanel = types_gen.defaultRowPanel;
const defaultFieldConfig = types_gen.defaultFieldConfig;
const defaultFieldConfigSource = types_gen.defaultFieldConfigSource;
const defaultMatcherConfig = types_gen.defaultMatcherConfig;
const defaultAnnotationQuery = types_gen.defaultAnnotationQuery;
const defaultAnnotationContainer = types_gen.defaultAnnotationContainer;

exports.VariableHide = VariableHide;
exports.defaultAnnotationContainer = defaultAnnotationContainer;
exports.defaultAnnotationQuery = defaultAnnotationQuery;
exports.defaultDashboard = defaultDashboard;
exports.defaultFieldConfig = defaultFieldConfig;
exports.defaultFieldConfigSource = defaultFieldConfigSource;
exports.defaultMatcherConfig = defaultMatcherConfig;
exports.defaultPanel = defaultPanel;
exports.defaultRowPanel = defaultRowPanel;
exports.defaultTimePickerConfig = defaultTimePickerConfig;
exports.defaultVariableModel = defaultVariableModel;
//# sourceMappingURL=dashboard.types.cjs.map
